module.exports = {

    fileSize(size, filesizeBase) {
        let cutoff, i, selectedSize = 0, selectedUnit = "b", unit, units, _i, _len;
        if (size > 0) {
            units = ['Tb', 'Gb', 'Mb', 'Kb', 'b'];
            for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
                unit = units[i];
                cutoff = Math.pow(filesizeBase, 4 - i) / 10;
                if (size >= cutoff) {
                    selectedSize = size / Math.pow(filesizeBase, 4 - i);
                    selectedUnit = unit;
                    break;
                }
            }
            selectedSize = Math.round(10 * selectedSize) / 10;
        }
        return selectedSize + " " + selectedUnit;
    }
};